import { Alert, Divider, Grid, Typography } from "@mui/material";
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import { useCallback, useMemo, useState } from "react";
import { formatarDecimalNumber } from "../../../../../helpers/masks";
import TableRowConfigs from "./components/TableRowConfigs";
import { TConfigBancariaDefault } from "../../../../../types/api/geral/configuracoes";
import { Link } from "react-router-dom";
import DialogPrimeiraConfig from "./DialogPrimeiraConfig";
import { TConfigBancariasSemIntegracao, TConfiguracaoBancaria } from "../../../../../types/api/financeiro/configuracoes-bancarias";
import DialogEditConfigFinanceiro from "./DialogEditConfigFinanceiro";

export default function Dashboard() {

    const [openModal, setOpenModal] = useState<TOpenModal>(null)
    const [openConfigModal, setOpenConfigModal] = useState<TOpenModalPrimeiraConfig>(null)

    //queries e mutations
    const { data: resultConfigDashboard, isLoading: isLoadingConfigDashboard } = useQuery({
        queryKey: ["configuracoes-financeiro-dashboard"],
        queryFn: () => axiosClient.get("/financeiro/configuracoes/pesquisar-contadores")
    });
    const { dataContadores }: IConfigDashboard = {
        dataContadores: resultConfigDashboard?.data
    }
    const { data, isLoading: isLoadingConfiguracoes } = useQuery({
        queryKey: ["configuracoes"],
        queryFn: () => axiosClient.get("/configuracoes", {
            params: {
                chave: 'config_bancaria_default'
            }
        })
    });
    const dataConfigDashboard: TConfigBancariaDefault = useMemo(() => data?.data, [data])

    const { data: dataConfig, isLoading: isLoadingIntegracoes } = useQuery({
        queryKey: ["pesquisar-integraçoes-bancarias"],
        queryFn: () => axiosClient.get("/financeiro/configuracoes/pesquisar-configuracoes-bancarias", {
            params: {
                limit: 100,
                page: 1,
                possui_integracao: true,
            }
        }),
        cacheTime: 1
    });
    //

    const dataConfigBancarias: TConfiguracaoBancaria[] = useMemo(() => dataConfig?.data.data, [dataConfig])

    const handleModalAction = useCallback((action: "open" | "close", label: TLabelModalDashboard, modal: TModalDashboard, value: TConfigBancariasSemIntegracao) => {
        if (action === "close") setOpenModal(null)

        if (action === "open" && label && value) setOpenModal({ open: true, label, modal, defaultValue: value })
    }, [])
    //

    const handleOpenModalPrimeiraConfig = useCallback((action: boolean, modal: TModalDashboard) => {
        if (action) {
            setOpenConfigModal({ open: true, modal })
        }
    }, [])

    return (
        <>
            {
                isLoadingConfigDashboard && isLoadingConfiguracoes && isLoadingIntegracoes &&
                <LoadingApiQuery />
            }

            {
                (!isLoadingConfigDashboard && dataContadores) &&
                <Grid container spacing={4}>
                    <Grid size={{xs: 4}}>
                        <Typography>Total titulos a pagar</Typography>
                        <Typography variant="h5" fontWeight="bold">{formatarDecimalNumber(dataContadores.qtd_titulos_pagar, 0)}</Typography>
                    </Grid>

                    <Grid size={{xs: 4}}>
                        <Typography>Total titulos a receber</Typography>
                        <Typography variant="h5" fontWeight="bold">{formatarDecimalNumber(dataContadores.qtd_titulos_receber, 0)}</Typography>
                    </Grid>
                </Grid>
            }

            <Divider sx={{ mt: 2, mb: 2 }} />
            {
                (!isLoadingConfiguracoes && !isLoadingIntegracoes && dataConfigDashboard && dataConfigBancarias) &&
                <Grid container spacing={1}>
                    <Grid size={{xs: 12}}>
                        <Typography variant="body1" fontWeight={'bold'} mb={2}>Registro de recebimento</Typography>
                    </Grid>

                    {
                        dataConfigBancarias.length <= 0 &&
                        <Grid size={{xs: 12}}>
                            <Alert severity="warning" icon={false} >
                                <Typography variant='caption'>
                                    Nenhuma configuração com integração bancária cadastrada. Clique para <Link
                                        to={'?menu=Configurações bancárias'}
                                    >cadastrar</Link>
                                    .
                                </Typography>
                            </Alert>
                        </Grid>
                    }
                    {
                        openConfigModal?.open && dataConfigBancarias.length >= 1 &&
                        <DialogPrimeiraConfig
                            dataConfigBancarias={dataConfigBancarias}
                            modal={openConfigModal.modal}
                            valorConfigDefault={dataConfigDashboard}
                            open={openConfigModal?.open}
                            handleClose={() => setOpenConfigModal(null)}
                        />
                    }
                    <Grid size={{xs: 12}}>
                        <TableRowConfigs
                            {...{ handleOpenModalPrimeiraConfig }}
                            modal="emissao_boleto"
                            label="emissão de boleto"
                            integracao={dataConfigDashboard.emissao_boleto}
                            {...{ handleModalAction }}
                        />
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <TableRowConfigs
                            {...{ handleOpenModalPrimeiraConfig }}
                            modal="emissao_pix"
                            label="gerar PIX QR Code"
                            integracao={dataConfigDashboard.emissao_pix}
                            {...{ handleModalAction }}
                        />
                    </Grid>
                </Grid>
            }
            {
                openModal &&
                <DialogEditConfigFinanceiro
                    {...{dataConfigBancarias}}
                    open={openModal.open}
                    label={openModal.label}
                    modal={openModal.modal}
                    handleClose={() => setOpenModal(null)}
                    defaultValueModal={openModal.defaultValue}
                    valorConfigDefault={dataConfigDashboard}
                />
            }
        </>
    )
}

interface IConfigDashboard {
    dataContadores: {
        qtd_titulos_pagar: number;
        qtd_titulos_receber: number
    }
}

export type TOpenModal = {
    open: boolean
    label: TLabelModalDashboard
    modal: TModalDashboard
    defaultValue: TConfigBancariasSemIntegracao;
} | null

export type TOpenModalPrimeiraConfig = {
    open: boolean
    modal: TModalDashboard
} | null
export type TModalDashboard = "emissao_boleto" | "emissao_pix"
export type TLabelModalDashboard = "emissão de boleto" | "gerar PIX QR Code"